import { SupplyChainFromStrategyIcon } from '@/svgs'
import React from 'react'

function SupplyChainFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Efficiency to Growth: Our Supply Chain & Logistics Software
               Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in supply chain and logistics software development, we build seamless, scalable, and high-performance solutions. Our structured approach is built to amplify operational performance, maximize the utilization of resources, and refine logistics.
            </p>

            <SupplyChainFromStrategyIcon />
         </div>
      </section>
   )
}

export default SupplyChainFromStrategy
